export const getIdForComponentNotification = (componentName, type, context) => {
    return `${componentName}-${type.toLowerCase()}-${context}`;
};
